import { ILoginPool, ILoginPoolsResponse, IUpdatedLoginPool } from '_/types/loginPools';
import zeusSdk from '_/utils/SDKs';

/**
 * Fetches login pools.
 * @param projectId Project Id.
 * @returns Login pool coollection.
 */
export const requestLoginPools = async (projectId: string): Promise<ILoginPoolsResponse> => {
  return (await zeusSdk.projects.getChildren(projectId, 'loginpools')) as ILoginPoolsResponse;
};

/**
 * Fetches a login pool.
 * @param projectId Project Id.
 * @param slug Login pool slug.
 * @returns Login pool.
 */
export const requestLoginPool = async (projectId: string, slug: string): Promise<ILoginPool> => {
  return (await zeusSdk.projects.getChildById(projectId, 'loginpools', slug)) as ILoginPool;
};

/**
 * Creates a new login pool.
 * @param projectId Project Id.
 * @param loginPool Login pool properties.
 * @returns Created login pool.
 */
export const postLoginPool = async (projectId: string, loginPool: IUpdatedLoginPool): Promise<ILoginPool> => {
  return (await zeusSdk.projects.createChild(projectId, 'loginpools', loginPool)) as ILoginPool;
};

/**
 * Updates an existing login pool.
 * @param loginPoolId Login pool Id.
 * @param loginPool Login pool properties.
 * @returns Updated login pool.
 */
export const patchLoginPool = async (loginPoolId: string, loginPool: IUpdatedLoginPool): Promise<ILoginPool> => {
  return (await zeusSdk.loginPools.patch(loginPoolId, loginPool)) as ILoginPool;
};
